import React, { useCallback, useEffect, useState } from "react";
import clsx from "clsx";
import { isSender } from "../../../../utils/chat.utils";
import { maskIfNumber, phoneNumberRegex } from "../MessageHelpers";
const PhoneNumberText = (props) => {
    const { number, isReceiver, isSnippet } = props;
    const [isMasked, setIsMasked] = useState(true);
    const [maskedNumber, setMaskedNumber] = useState('');
    const unMaskHandler = useCallback(() => {
        setIsMasked(false);
    }, []);
    useEffect(() => {
        let masked = maskIfNumber(number);
        setMaskedNumber(masked);
    }, []);
    return (React.createElement(React.Fragment, null, (!isReceiver || isSnippet) ? React.createElement("p", { style: { display: 'inline' } }, isSnippet ? maskedNumber : number) : React.createElement("a", { onClick: unMaskHandler, href: `tel:${number}` }, isMasked ? maskedNumber : number)));
};
export const Text = (props) => {
    const { message, isReceiver, isSnippet } = props;
    const [textArray, setTextArray] = useState([]);
    let lastMessageIndex = 0;
    useEffect(() => {
        setTextArray(message.split('\n'));
        lastMessageIndex = textArray.length - 1;
    }, [message]);
    return React.createElement(React.Fragment, null, textArray.map((text, index) => {
        const phoneNumbersWithPositions = [];
        let match;
        while ((match = phoneNumberRegex.exec(text)) !== null) {
            const phoneNumber = match[0];
            const startPosition = match.index;
            const endPosition = phoneNumberRegex.lastIndex;
            phoneNumbersWithPositions.push({ phoneNumber, startPosition, endPosition });
            phoneNumberRegex.lastIndex = phoneNumberRegex.lastIndex + 1;
        }
        let cursorIndex = 0;
        if (phoneNumbersWithPositions.length < 1)
            return React.createElement(React.Fragment, null,
                text,
                index < lastMessageIndex ? React.createElement("br", null) : React.createElement(React.Fragment, null));
        return phoneNumbersWithPositions.map((phoneNumber, i) => {
            let temp = cursorIndex;
            cursorIndex = phoneNumber.endPosition;
            return React.createElement(React.Fragment, null,
                React.createElement("p", { style: { display: 'inline' } }, text.substring(temp, phoneNumber.startPosition)),
                React.createElement(PhoneNumberText, { number: phoneNumber.phoneNumber, isReceiver: isReceiver, isSnippet: isSnippet }),
                index < lastMessageIndex ? React.createElement("br", null) : React.createElement(React.Fragment, null),
                i === phoneNumbersWithPositions.length - 1 && React.createElement("p", { style: { display: 'inline' } }, text.substring(cursorIndex)));
        });
    }));
};
const TextComponent = (props) => {
    const { message } = props;
    const isReceiver = !isSender(message);
    return (React.createElement("div", { className: clsx('customMessageShadow', 'p-5 ', `${isReceiver ? 'bg-white text__msg-box-sender ' : ' customOpensooqBgColor text__msg-box-receive'}`, 'text-dark  mw-lg-400px', `text-${message.sender_id !== message.oid ? 'start' : 'end'}`), "data-kt-element": 'message-text', key: message.mid },
        React.createElement(Text, { message: message.text, isReceiver: isReceiver, isSnippet: false })));
};
export default React.memo(TextComponent);
